import { apiFetch, loadApiConfig } from "../services/api";

// React owns the displayed image; asynchronous calls never mutate another account's DOM.
export async function refreshAvatar(): Promise<string | null> {
  const response = await apiFetch("/account/avatar", { cache: "no-store" });
  if (!response.ok) throw new Error(`avatar endpoint failed: ${response.status}`);
  const payload = await response.json();
  const url = payload?.avatar_url;
  if (!url) return null;
  return new URL(url, await loadApiConfig()).href;
}
